import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const RedeemRewardDetail = () => {
    const { state } = useLocation();
    const { data } = state;

    return (
        <>
            <Row>
                {/* <Col sm={4}>
                    <div className="detail-heading ms-5">
                        Redeem Point Details
                    </div>
                </Col> */}
                <Col sm={4} md={3} lg={2} className="text-end ms-auto">
                    <Link to="/redeemed-rewards">
                        <Button className="theme-cancel-btn px-5 py-2">Close</Button>
                    </Link>
                </Col>
            </Row>
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="m-3 ps-0 ms-0">
                    <Row>
                        <Col md={4}>
                            <div className="detail-small-heading">Commuter Name</div>
                            <div className="detail-value">{data?.name}</div>
                        </Col>

                        <Col md={4}>
                            <div className="detail-small-headingg">Commuter Email</div>
                            <div className="detail-value">{data?.email}</div>
                        </Col>

                        <Col md={4}>
                            <div className="detail-small-heading">Points Spent</div>
                            <div className="detail-value">{data?.reward.requiredPoints}</div>
                        </Col>
                    </Row>

                    <Row className="mt-5">
                        <Col md={4}>
                            <div className="detail-small-heading">Reward Name</div>
                            <div className="detail-value">{data?.reward.name}</div>
                        </Col>
                        <Col md={4}>
                            <div className="detail-small-heading">Description</div>
                            <div className="detail-value">{data?.reward?.description}</div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default RedeemRewardDetail;
